import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ld-compact-paginator',
  imports: [TranslocoDirective],
  templateUrl: './compact-paginator.component.html',
  styleUrl: './compact-paginator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompactPaginatorComponent {
  pageIndex = input.required<number>();

  length = input.required<number>();

  pageSize = input.required<number>();

  pageChange = output<number>();

  protected readonly totalPages = computed(() => {
    const size = this.pageSize();
    return size > 0 ? Math.ceil(this.length() / size) : 0;
  });

  protected readonly currentPage = computed(() => this.pageIndex() + 1);

  protected readonly isFirstPage = computed(() => this.pageIndex() === 0);

  protected readonly isLastPage = computed(() => this.currentPage() >= this.totalPages());

  protected goToPrevious(): void {
    if (!this.isFirstPage()) {
      this.pageChange.emit(this.pageIndex() - 1);
    }
  }

  protected goToNext(): void {
    if (!this.isLastPage()) {
      this.pageChange.emit(this.pageIndex() + 1);
    }
  }
}
